import { useNavigate } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Progress } from "@/components/ui/progress";
import { BookLoader } from "@/components/BrandLoader";
import { BookMenu, StatusBadge } from "@/components/library/BookMenu";

export const Cover = ({ b, rounded = "rounded-xl" }) => {
  const pct = b.progress?.total ? (b.progress.done / b.progress.total) * 100 : 5;
  return (
    <>
      {b.cover
        ? <img src={fileUrl(b.cover)} alt={`${b.title} cover`} loading="lazy" draggable={false} className={`h-full w-full object-cover ${rounded}`} />
        : <div className={`grid h-full w-full place-items-center bg-[#EEF2F8] ${rounded}`}><BookLoader size={30} /></div>}
      {b.status === "processing" && <div className="absolute inset-x-3 bottom-3"><Progress value={pct} className="h-1 bg-white/70" /></div>}
    </>
  );
};

export const GridCard = ({ b, shelves, onDelete, onMove }) => {
  const navigate = useNavigate();
  return (
    <div className="group" data-testid={`book-card-${b.book_id}`}>
      <button onClick={() => navigate(`/editor/${b.book_id}`)} className="relative block aspect-[3/4] w-full overflow-hidden rounded-2xl bg-[#EEF2F8] p-2.5 shadow-[9px_9px_16px_rgba(166,180,208,.6),-9px_-9px_16px_rgba(255,255,255,.8)]" data-testid={`open-book-${b.book_id}`}>
        <div className="relative h-full w-full overflow-hidden rounded-xl transition-transform duration-500 group-hover:scale-[1.03]"><Cover b={b} /></div>
      </button>
      <div className="mt-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <h3 className="truncate font-display text-lg font-bold" data-testid={`book-title-${b.book_id}`}>{b.title}</h3>
          <p className="text-xs text-[#64748B]">{b.page_count || 0} pages · <StatusBadge b={b} /></p>
        </div>
        <BookMenu b={b} shelves={shelves} onDelete={onDelete} onMove={onMove} />
      </div>
    </div>
  );
};
